<template>
  <div class="tree-select-dropdown-selected-item">
    <div class="tree-select-dropdown-selected-item__name">
      {{ itemName }}
    </div>
    <div
      v-if="!readonly"
      class="tree-select-dropdown-selected-item__delete"
      @click="$emit('removeItem')"
    >
      <MIcon
        :icon="iconCross"
      />
    </div>
  </div>
</template>

<script>
  import MIcon from 'components/Design/MIcon';
  import iconCross from 'assets/icons/cross.svg';

  export default {
    name: 'TreeSelectDropdownSelectedItem',
    components: {MIcon},
    props: {
      item: {
        type: Object,
        required: true
      },
      readonly: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        iconCross
      };
    },
    computed: {
      itemName () {
        return this.item.name;
      }
    }
  };
</script>

<style>
  .tree-select-dropdown-selected-item {
    display: flex;

    align-items: center;

    width: 100%;

    background: var(--gray-table-color);

    border-radius: 5px;
  }

  .tree-select-dropdown-selected-item__delete {
    cursor: pointer;

    display: flex;

    flex-grow: 0;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;

    width: 16px;
    height: 100%;

    margin-right: 4px;
  }

  .tree-select-dropdown-selected-item__delete svg {
    color: var(--gray-text-color);

    width: 14px;
    height: 14px;
  }

  .tree-select-dropdown-selected-item__delete:hover svg {
    color: var(--text-main-color);
  }

  .tree-select-dropdown-selected-item__name {
    text-overflow: ellipsis;

    overflow: hidden;

    flex-grow: 1;

    width: 100%;

    padding: 6px 8px;
  }
</style>
